//
// - cookie-consent.js
// -
// - tuxwerk OHG
// - Freiburg im Breisgau, im Juli 2020
// -
// -

"use strict";

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

function addIframeMask(el, style, text, showDialog, allowAlways) {
  el.contentDocument.body.innerHTML = "<h1>Im Iframe</h1><p></p><button id='allow_once' onclick=\"window.parent.postMessage('allowElement','*');\">Element anzeigen</button><button id='allow_all' onclick=\"window.parent.postMessage('allowCategory', '*');\">Alle erlauben</button>";
  var styleLink = el.contentDocument.createElement("link");
  styleLink.rel = "stylesheet";
  styleLink.href = "data:text/css," + encodeURIComponent(style);
  el.contentDocument.body.appendChild(styleLink);
  for (var k = 0; k < Object.keys(text).length; k++) {
    el.contentDocument.body.querySelector(Object.keys(text)[k]).innerHTML = text[Object.keys(text)[k]];
  }
  window.addEventListener('message', function(ev) {
    switch(ev.data) {
    case 'allowElement':
      ev.source.frameElement.src = ev.source.frameElement.dataset.src;
      break;
    case 'showCookieDialog':
      showDialog();
      break;
    case 'allowCategory':
      allowAlways();
    }
  });
}

function addDivMask(el, className, text, allowAlways) {
  var ev = document.createEvent('Event');
  ev.initEvent('masked_divs_changed', true, true);
  var m = document.createElement("div");
  m.className = className;
  m.innerHTML = "<h1>Maske</h1><p>Text</p><button class='cookie_consent_allow_once'>Anzeigen</button> <button class='cookie_consent_allow_all'>Immer erlauben</button>";
  for (var k = 0; k < Object.keys(text).length; k++) {
    m.querySelector(Object.keys(text)[k]).innerHTML = text[Object.keys(text)[k]];
  }
  var elHeight = el.offsetHeight;
  var elWidth = el.offsetWidth;
  var elLeft = el.offsetLeft;
  var elTop = el.offsetTop;
  var checkIframeChange = function() {
    if (elHeight !== el.offsetHeight || elWidth !== el.offsetWidth || elTop !== el.offsetTop || elLeft !== el.offsetLeft) {
      document.body.dispatchEvent(ev);
      elHeight = el.offsetHeight;
      elWidth = el.offsetWidth;
      elTop = el.offsetTop;
      elLeft = el.offsetLeft;
    }
  };
  setInterval(checkIframeChange, 100);
  var buttonAllowOnce = m.querySelector('.cookie_consent_allow_once');
  var buttonAllowAll = m.querySelector('.cookie_consent_allow_all');
  buttonAllowOnce.addEventListener('click', function(ev) {
    ev.preventDefault();
    m.style.display = 'none';
  });
  buttonAllowAll.addEventListener('click', function(ev) {
    ev.preventDefault();
    m.style.display = 'none';
    allowAlways();
  });
  m.style.position = 'absolute';
  var maskElement = function() {
    m.style.height = el.offsetHeight + 'px';
    m.style.width = el.offsetWidth + 'px';
    m.style.left = el.offsetLeft + 'px';
    m.style.top = el.offsetTop + 'px';
  }
  maskElement();
  el.parentElement.appendChild(m);

  document.body.addEventListener('masked_divs_changed', maskElement);
}


function ConsentCookie(categories, cookieName, attrs) {
  //
  // cookie will be saved as
  //
  //  #{cookieName}=#{JSONized Values-Object}
  //  where values-object is {category1: true/false, category2: true/false,...}
  //
  //  attributes:
  //
  //    this.cookieName
  //    this.categories
  //
  //  methods:
  //
  //   this.getCookieVals():
  //
  //     return Values-Object if cookie is defined, valid and complete
  //     return null if cookie not defined, invalid or incomplete
  //
  //  this.setCookieVals(hash, attrs)
  //
  //     arguments:
  //       hash Javascript Object
  //       attrs Javascript Object, ignores all keys but "Max-Age"
  //
  //     side effects:
  //     sets cookie if hash contains all categories
  //
  //     return:
  //      true if cookie was set
  //      false if cookie could not be set
  //
  //
  //  this.enableScripts():
  //
  //  side effects:
  //
  //    for all categories set in the cookie:
  //
  //      change <tag data-src="..." data-consent="#{category}">
  //             to <tag  src="..." data-consent="#{category}">
  //
  //      copy inline scripts <script type="text/plain" data-consent="#{category}>...</script>
  //      into new node <script type="application/javascript" data-consent="#{category}>...</script>
  //
  //
  this.cookieName = cookieName;
  this.categories = categories;
  this.attrs = attrs || [];
  if(this.getCookieVals() !== null) {
    this.enableScripts();
  }
}

ConsentCookie.prototype = {
  allowedCategory: function(category) {
    var v = this.getCookieVals();
    if (!v) {
      return false;
    } else {
      return v[category];
    }
  },
  allowCategory: function(category) {
    var h = this.getCookieVals();
    if (!h) { return false; }
    h[category] = true;
    return this.setCookieVals(h);
  },
  allCategoriesIncluded: function(hash) {
    for(var i = 0; i < this.categories.length; i++) {
      if (!hash.hasOwnProperty(this.categories[i])) {
	//console.log(this.categories[i] + " not found");
        return false;
      }
    }
    return true;
  },
  getCookieValue: function() {
    var b = document.cookie.match('(^|;)\\s*' + this.cookieName + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : null;
  },
  getCookieVals: function() {
    var json = this.getCookieValue();
    if (json == null)
      return null;

    var values = JSON.parse(json);
    if (this.allCategoriesIncluded(values)) {
      return values;
    } else {
      return null;
    }
  },
  setCookie: function(val) {
    var attrString = "";
    if (this.attrs['Max-Age']) {
      attrString += "Max-Age=" + this.attrs['Max-Age'] + ";";
    }
    if (this.attrs['SameSite']) {
      attrString += "SameSite=" + this.attrs['SameSite'] + ";";
    }
    if (this.attrs['Path']) {
      attrString += "Path=" + this.attrs['Path'] + ";";
    }
    document.cookie = this.cookieName + "=" + val + ";" + attrString;
  },
  setCookieVals: function(cookies) {
    if (this.allCategoriesIncluded(cookies)) {
      var oldVals = this.getCookieVals();
      var changed = false;
      if (oldVals !== null) {
        for (var i = 0; i < Object.keys(cookies).length; i++) {
          if (cookies[Object.keys(cookies)[i]] !==
	      oldVals[Object.keys(cookies)[i]]) {
            changed = true;
          }
        }
      } else {
        changed = true;
      }

      if (changed) {
        this.setCookie(JSON.stringify(cookies));
        this.enableScripts();
        //location.reload(); // FIXME: should we really reload?
      }
      return true;
    } else {
      return false;
    }
  },
  enableInlineScript: function(el) {
    var newScript = document.createElement('script');
    newScript.setAttribute("type", "application/javascript");
    newScript.innerHTML = el.innerHTML;
    document.body.appendChild(newScript);
  },
  enableScripts: function() {
    var cvals = this.getCookieVals();
    var that = this;
    document.querySelector("#cookie-consent-outer").style.display = 'none';
    this.categories.forEach(function(key) {
      if (cvals[key]) {
        document.querySelectorAll('[data-consent="' + key + '"]').forEach(function(element) {
          if (element.dataset.src) {
            element.src = element.dataset.src;
          } else if (element.tagName === 'SCRIPT') {
            that.enableInlineScript(element);
          }
	});
      }
    });
  }
}

function CookieConsentForm(element, config) {
  this.hide_on_pages = config.hide_on_pages || [];
  this.element = element;
  this.locale = config.locale;
  this.texts = config.texts;
  this.categories = config.categories;
  this.element.innerHTML = config.html_template || '<form><h1></h1><p></p><div class="cookie_consent_checkboxes"></div><button type="submit" value="allow_selection"></button> <button type="submit" value="allow_all"></button> <a href="" class="cookie_consent_details_button"></a><table class="cookie_consent_details"><thead /></table></form>';
  this.consentCookie = new ConsentCookie(Object.keys(this.categories),
					 config.cookie_name,
					 config.cookie_attrs);
  this.fillText();
  this.maskIframesAndDivs();

  // FIXME: this resets the saved cookie settings
  if (this.consentCookie.getCookieVals() === null) {
    if (this.showOnPage())
      this.showDialog();
  } else {
    this.hideDialog();
  }
  var that = this;

  this.element.querySelector('.cookie_consent_details').hidden = true;

  this.element.querySelector('.cookie_consent_details_button').addEventListener('click', function(el) {
    el.preventDefault();
    var details = that.element.querySelector('.cookie_consent_details');
    details.hidden = !details.hidden;
  });

  this.element.querySelectorAll("button").forEach(function(el) {
    el.addEventListener('click', function(el) {
      el.preventDefault();
      that.hideDialog();
      var cookies = {};
      Object.keys(that.categories).forEach(function(category) {
	cookies[category] =
	  el.target.value == 'allow_all' || that.selectedCategory(category);
      });
      that.consentCookie.setCookieVals(cookies);
    });
  });
}

CookieConsentForm.prototype = {
  selectedCategory: function(category) {
    return this.categories[category].hidden
      ?
      false
      :
      this.element.querySelector('[name="' + category + '"]').checked;
  },
  hideDialog: function() {
    this.element.style.display = 'none';
  },
  showDialog: function() {
    this.element.style.display = 'block';
    this.makeCheckboxes();
  },
  showOnPage: function() {
    for (var i = 0; i < this.hide_on_pages.length; i++) {
      if (window.location.pathname === this.hide_on_pages[i]) {
	return false;
      }
    }
    return true;
  },
  categoryText: function(category, type) {
    try {
      return this.categories[category][type][this.locale];
    }
    catch (e) {
      return "";
    }
  },
  fillText: function() {
    var keys = Object.keys(this.texts);
    for (var i = 0; i < keys.length; i++) {
      this.element.querySelector(keys[i]).innerHTML =
	this.texts[keys[i]][this.locale];
    }
    var t = this.element.querySelector('.cookie_consent_details');
    var categories = Object.keys(this.categories);
    for (var i = 0; i < categories.length; i++) {
      if (this.categories[categories[i]].hidden) continue;

      t.innerHTML += '<tr><td>' + this.categoryText(categories[i], "label") + '</td><td>' + this.categoryText(categories[i], "text") + '<br />' + this.categoryText(categories[i], "details") + '</td>';
    }
  },
  makeCheckboxes: function() {
    var el = this.element.querySelector('.cookie_consent_checkboxes');
    el.innerHTML = '';
    for (var i = 0; i < Object.keys(this.categories).length; i++) {
      var conf = this.categories[Object.keys(this.categories)[i]];
      if (conf.hidden) continue;

      el.innerHTML += '<label title="' + conf.text[this.locale] + '"><input type="checkbox" ' + ((conf.mandatory || (this.consentCookie.getCookieVals() !== null && this.consentCookie.getCookieVals()[Object.keys(this.categories)[i]]  === true)) ? 'checked' : '') + ' name="' + Object.keys(this.categories)[i] + '" '+ (conf.mandatory ? 'disabled' : '') +  ' ><span>' + conf.label[this.locale] + '</span></label>';
    }
  },
  maskIframesAndDivs: function() {
    var disallowedIframes = Array.prototype.slice.call(document.querySelectorAll('iframe[data-consent]'));
    var disallowedDivs = Array.prototype.slice.call(document.querySelectorAll('div[data-consent]'));
    var i, element, category;
    for (i = 0; i < disallowedIframes.length; i++) {
      element = disallowedIframes[i];
      category = element.dataset.consent;
      if (!this.consentCookie.allowedCategory(category)) {
        addIframeMask(
	  element,
	  this.categories[category].iframeStyle,
	  this.categories[category].iframeText[this.locale],
	  this.showDialog,
	  (function() { this.consentCookie.allowCategory(category); }).bind(this)
	)
      }
    }
    for (i = 0; i < disallowedDivs.length; i++) {
      element = disallowedDivs[i];
      category = element.dataset.consent;
      if (!this.consentCookie.allowedCategory(category)) {
        addDivMask(
	  element,
	  'consent_cookie_divmask',
	  this.categories[category].iframeText[this.locale],
	  (function() { this.consentCookie.allowCategory(category) }).bind(this)
	);
      }
    }
  }
};

export default CookieConsentForm;
